import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { AbstractCmsBlockComponent } from '../../../../../../cms/block/abstract-cms-block.component';
import { IProductSizeGuideContent } from '../size-guide/product-layout-sidebar-size-guide.interfaces';

export const PRODUCT_LAYOUT_SIDEBAR_HOW_TO_MEASURE_COMPONENT_CONFIG = {
    id: 'how-to-measure',
    block: {
        url: 'how-to-measure'
    },
    onDemandOnly: true,
    name: 'How to measure modal',
    description: 'How to measure modal component',
    fields: [
        {
            key: 'components',
            type: NICmsContentField.EFieldType.components,
            title: 'Components',
            default: []
        }
    ]
};

@Component({
    selector: 'product-layout-sidebar-how-to-measure',
    templateUrl: './product-layout-sidebar-how-to-measure.component.html',
    imports: [ICmsClientModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<ProductLayoutSidebarHowToMeasureComponent>(PRODUCT_LAYOUT_SIDEBAR_HOW_TO_MEASURE_COMPONENT_CONFIG)
export class ProductLayoutSidebarHowToMeasureComponent extends AbstractCmsBlockComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    override content!: IProductSizeGuideContent;
}
